import { matchPath } from 'react-router-dom';
import type { RecordRef } from './types';

/**
 * Pages whose URL names a record the agents can read. The drawer is rendered by
 * the shell, outside the feature routes, so useParams() is empty there: match
 * the pathname instead. Demo: the CA assessment page only, whose :id is the
 * MortgageAssessment id that runs are keyed on (decision #5). The
 * /client/details|overview pages carry an online-assessment source id instead.
 */
const RECORD_ROUTES: { pattern: string; type: RecordRef['type'] }[] = [
  {
    pattern: '/application/credit-analyst/assessment/:id/*',
    type: 'assessment',
  },
  { pattern: '/settings/lenders/:id', type: 'lender' },
];

export const isLenderRecord = (ref: RecordRef | null): boolean =>
  ref?.type === 'lender';

export function resolveRecordRef(pathname: string): RecordRef | null {
  for (const route of RECORD_ROUTES) {
    const id = matchPath(route.pattern, pathname)?.params.id;
    if (id) return { type: route.type, id };
  }
  return null;
}
